import React, { useEffect, useRef } from "react";

export const NewsMedia = ({ src, alt, className, style, poster }) => {
  const isVideo = /\.mp4($|\?)/i.test(src || "");
  const ref = useRef(null);

  useEffect(() => {
    if (isVideo && ref.current) {
      ref.current.muted = true;
      const p = ref.current.play();
      if (p && p.catch) p.catch(() => {});
    }
  }, [isVideo, src]);

  if (isVideo) {
    return (
      <video
        ref={ref}
        src={src}
        poster={poster || undefined}
        className={className}
        style={style}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        data-testid="news-media-video"
      />
    );
  }
  return <img src={src} alt={alt} className={className} style={style} />;
};
